export default __webpack_public_path__ + "static/media/braintree-logo.9d588dee.png";